import { ApiRequest } from './api-request';
import { ApiRequestPagination } from './api-request-pagination';

/**
 * Api paginated request dto
 */
export class ApiPaginatedRequest extends ApiRequest {
	pagination?: ApiRequestPagination;
}
